class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    // 原始代码
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	return fetch('/cart.js');
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
    // this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
    //   this.val = this.querySelector('input[name="discount"]').value;
    //   if (!this.val ||  this.val == '') {
    //     localStorage.removeItem('removeItem');
    //     console.log('删除');
    //     fetch('/discount/')
    //       .then(() => {
    //         return fetch('/cart.js'); // 获取最新购物车数据
    //       })
    //       .then(response => response.json())
    //       .then(cart => {
    //         // 用新数据更新购物车抽屉的显示
    //         // 例如更新总价:
    //         document.querySelector('.cart-total-price').textContent = cart.total_price / 100;
            
    //         // 更新每个商品的价格:
    //         cart.items.forEach((item, index) => {
    //           const itemElement = document.querySelectorAll('.cart-item')[index];
    //           itemElement.querySelector('.item-price').textContent = item.final_line_price / 100;
    //         });
    //       });
    //   } else {
    //     localStorage.setItem('storedDiscount', this.val);
    //     fetch(`/discount/${this.val}`)
    //         .then((response) => response.text())
    //         .then((responseText) => {
        
    //     });
    //   }
    // });
  }
}

customElements.define('coupon-code', CouponCode);